<p-toast position="top-right"></p-toast>

<div class="root-body"
     [ngClass]="{
    'root-body-sidebar-slim': configService.config.menuMode === 'sidebar' || configService.config.menuMode === 'slim',
    'root-body-sidebar-static': configService.config.menuMode === 'sidebar' && configService.config.sidebarStatic,
    'root-body-horizontal': configService.config.menuMode === 'horizontal'}">

    <div class="flex flex-row mb-3" style="align-items: center">
        <div class="head-title">
            Report Driver Performance
        </div>

        <div class="mr-2 ml-auto">
            <p-calendar [appendTo]="'body'"
                        [inputStyle]="{'height': '45px', 'background-color': 'white', 'color': 'black'}"
                        selectionMode="range" [readonlyInput]="true" [showIcon]="true" [(ngModel)]="selectedDateRange"
                        (ngModelChange)="handleFilterChange($event)" />
        </div>

        <div class="report-customer-header__separator"></div>

        <div class="mr-2">
            <button style="height: 35px;" class="bluedark-btn" pButton label="Export Data" (click)="op.toggle($event)"></button>

            <p-overlayPanel #op [style]="{width: '180px'}">
                <ng-template pTemplate>
                    <div class="report-top-button mt-3" (click)="exportOrdersCompletedAndUnallocated(exportFileTypeEnum.Excel)">Download Excel Report</div>
                </ng-template>
            </p-overlayPanel>
        </div>
    </div>

    <div class="card flex justify-content-center" *ngIf="isLoading">
        <p-progressSpinner styleClass="w-4rem h-4rem"
                           strokeWidth="8"
                           fill="var(--surface-ground)"
                           animationDuration=".5s" />
    </div>

    <div class="card" *ngIf="!isLoading">
        <p-scrollPanel [style]="{width:'100%', height: 'calc(78vh)'}"
                       [styleClass]="'app-scrollpanel'">
            <p-table [value]="drivers" [tableStyle]="{ 'min-width': '50rem' }">
                <ng-template pTemplate="header">
                    <tr>
                        <th>Date</th>
                        <th>Driver ID</th>
                        <th>Completed Trips</th>
                        <th>Completion Rate</th>
                        <th>Online Time</th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-driver>
                    <tr>
                        <td>{{ driver.Date }}</td>
                        <td>{{ driver.DriverId }}</td>
                        <td>{{ driver.CompletedTrips }}</td>
                        <td>{{ driver.CompletionRate }}</td>
                        <td>{{ driver.OnlineTime }}</td>
                    </tr>
                </ng-template>
            </p-table>
        </p-scrollPanel>
    </div>
</div>
